




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Request {
    title: string;
}

@Component({ components: { SimpleText } })
export default class Title extends Vue {
    @Prop() public request!: Request;

    public static getNeededFields(): string[] {
        return [
            "request.title",
            "request.children.title",
        ];
    }
}
